import { render, staticRenderFns } from "./FeelingCustom.vue?vue&type=template&id=a2db230a"
import script from "./FeelingCustom.vue?vue&type=script&lang=js"
export * from "./FeelingCustom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports